import { useNotFoundStatusCode } from '@xing-com/crate-xinglet';
import { SingleSizeIllustrationErrorBigErrorPage404 } from '@xing-com/illustrations';
import { BREAKPOINTS, useMediaListener } from '@xing-com/util';

import { Styled } from './styles';

interface NotFoundProps {
  copy: string;
}

const NotFound: React.FC<NotFoundProps> = ({ copy }) => {
  useNotFoundStatusCode();
  const matchedMedia = useMediaListener();
  const illustrationSize = matchedMedia === BREAKPOINTS.handheld ? 208 : 300;

  return (
    <Styled.NotFoundContainer>
      <SingleSizeIllustrationErrorBigErrorPage404
        width={illustrationSize}
        height={illustrationSize}
      />
      <Styled.NotFoundCopy size="large">{copy}</Styled.NotFoundCopy>
    </Styled.NotFoundContainer>
  );
};

export default NotFound;
